import { toast } from 'react-toastify';

const create = (level, message, opts = {}) => {
  const _opts = {
    position: 'bottom-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    ...opts
  };

  if (level === 'default') {
    return toast(message, _opts);
  }

  return toast[level](message, _opts);
};

export const addDefaultNotification = (message, opts = {}) => create('default', message, opts);
export const addInfoNotification = (message, opts = {}) => create('info', message, opts);
export const addSuccessNotification = (message, opts = {}) => create('success', message, opts);
export const addWarningNotification = (message, opts = {}) => create('warn', message, opts);
export const addErrorNotification = (message, opts = {}) => create('error', message, opts);

export default {
  addDefault: addDefaultNotification,
  addInfo: addInfoNotification,
  addSuccess: addSuccessNotification,
  addWarning: addWarningNotification,
  addError: addErrorNotification,
};
